import { cn } from '@/shared/utils/cn';

export type PageIndicatorProps = {
  className?: string;
  currentPage: number;
  count: number;
  onPageClick?: (pageIndex: number) => void;
};

export const PageIndicator = ({
  className,
  currentPage,
  count,
  onPageClick,
}: PageIndicatorProps) => {
  return (
    <div
      className={cn(
        'flex flex-row gap-2 rounded-[50px] bg-custom-dark-grey px-3 py-2',
        className,
      )}
    >
      {[...Array(count)].map((_, index) => (
        <Dot
          key={index}
          active={index === currentPage}
          onClick={() => onPageClick?.(index)}
          clickable={!!onPageClick}
        />
      ))}
    </div>
  );
};

const Dot = ({
  active,
  onClick,
  clickable,
}: {
  active: boolean;
  onClick?: () => void;
  clickable: boolean;
}) => {
  return (
    <div
      className={cn(
        'h-2 w-2 rounded-full transition-colors',
        active ? 'bg-white' : 'bg-white/50',
        clickable && 'cursor-pointer hover:bg-white/75',
      )}
      onClick={onClick}
    />
  );
};
